import TableauLinks from "./routes/TableauLinks/TableauLinks.vue"

const SettingRoutes = [
  {
    path: "tableaulinks",
    name: "TableauLinks",
    component: TableauLinks,
  },
  
];

export default SettingRoutes;
